import authenticatedAxios from './authenticatedAxios';

const redisDetails = async () => {
   // CRITICAL FIX: For MSIL users, check email; for MASS users, check uid
   // MSIL admin users don't have uid in sessionStorage, they have email
   const uid = sessionStorage.getItem('uid');
   const email = sessionStorage.getItem('email');
   const role = sessionStorage.getItem('role');
   
   // Determine the Redis key based on user type
   let redisKey = null;
   
   if (uid) {
     // MASS user - use uid
     redisKey = uid;
   } else if (email && (role === 'MSIL' || role === 'SUPER_ADMIN' || role === 'ADMIN')) {
     // MSIL admin user - use email as Redis key
     redisKey = email;
   }
   
   console.log("Redis key in redis api call: ", redisKey, " (uid:", uid, ", email:", email, ", role:", role, ")");
   
   if (!redisKey) {
     console.error("No UID or email found in sessionStorage");
     throw new Error("User ID not found. Please login again.");
   }
   
   const REDIS_API_URL = `/api/v1/redis/getRedisData/${redisKey}`;
   
   try {
     const responseRedis = await authenticatedAxios.get(REDIS_API_URL);
     const responseData = responseRedis.data;
     
     // Handle both string format (MASS users) and object format (MSIL users)
     if (typeof responseData === 'string') {
       const parts = responseData.split('|');
       if (parts.length >= 3) {
         // Step 2: Parse the JSON part
         const jsonResponse = JSON.parse(parts[2]);
         console.log("Parsed JSON response:", jsonResponse);
         return jsonResponse;
       }
     } else if (typeof responseData === 'object') {
       // MSIL users might have UserSession object
       console.log("Redis response is object:", responseData);
       return responseData;
     }
     
     throw new Error("Unexpected Redis response format");
   } catch (error) {
     console.error("Error fetching redis details:", error);
     throw error;
   }
};

export default { redisDetails };
